export interface StatisticState {
    mailNotifyGroupBy: any[],
    mailNotifyGroupByOptionally?: any[],

    mailNotifyStatisticGroup?: any,

    mailNotifyStaticGroup?: any,

    mailNotifyStaticDetail?: any,
    mailNotifyStaticDetailFlag?: string,

}

export class MailNotifyGroupFilterParams {
    date_from: string;
    date_to: string;
    group_by: string;

    partner?: string = undefined;
    service_provider?: string = undefined;
    template_id?: number = undefined;
    bulk_id?: number = undefined;

    // исключително для входящих
    service_number?: number;
    originator_operator?: string;
    broker_account_login?: number = undefined;
    message_type?: number = undefined;
    message_direction: string;
    mn_service_name?: string = undefined;
    mn_tmpl?: string = undefined;
    routes?: string = undefined;

    constructor(date_from: string, date_to: string, group_by: string) {
        this.date_from = date_from;
        this.date_to = date_to;
        this.group_by = group_by;
        this.message_direction = "mt";
    }
}

export interface DetailFilterParams {
    date_from: string | null,
    date_to: string | null,
    recipient?: number | null,
    partner?: string | null,
    service_provider?: string | null,
    status?: string | null,
    message_category?: string | null,
    error_code?: string | null,
    message_type?: string | null,
    message?: string | null,
    sent_date_from?: string | null,
    sent_date_to?: string | null,
    deliver_date_from?: string | null,
    deliver_date_to?: string | null,
    template_id?: string | null,
    bulk_id?: string | null,
    broker_account_login?: string | null,
    partner_user_login?: string | null,
    id?: string | null,
    external_id?: string | null,
    ext_id1?: string | null,
    ext_id2?: string | null,
    ext_id3?: string | null,
    ext_id4?: string | null,
    ext_id5?: string | null,
    page_number: number,
    message_direction: string,
    mn_service_name?: string | null,
    mn_tmpl?: string | null,
    routes?: string | null,
}

export interface MailNotifyDetailInfoItem {
    broker_account_login: null | string,
    message_category:null | string,
    bulk_id: number | null,
    template_id: number | null,
    error_code: number | null,
    error_description: string,
    external_id: null | string,
    id: string,
    message: string,
    module: string,
    partner: string,
    partner_user_login: string,
    partner_price: null | string,
    provider_price: null | string,
    recipient: string,
    service_provider: null | string,
    status: string,
    defer_date: string | null,
    sent_date: string | null,
    connection_type: string | null,
    parent_message_id: string | null,
    parent_message_transport: string | null,
    ext_id1?: string | null,
    ext_id2?: string | null,
    ext_id3?: string | null,
    ext_id4?: string | null,
    ext_id5?: string | null,
}

export interface MailNotifyGroupIncomItem {
    date?: string,
    processed: number,
    error: number,
    total: number,
}

export interface MailNotifyDetailItem {
    id: string;
    create_date: string;
    originator: string;
    recipient: string;
    partner: string;
    service_provider: string;
    subject: string;
    status: string;
    error_code?: number;
  }

  export interface MailNotifyGroupItem {
    date?: string;
    originator?: string;
    service_provider?: string;
    partner?: string;
    template_id?: string;
    bulk_id?: number;
    delivered: number;
    not_delivered: number;
    transmitted: number;
    expired: number;
    failed: number;
    read: number;
    rejected: number;
    deferred: number;
    total: number;
    partner_price: string;
    provider_price: string;
  }
